const stripeKey = window.StripeConfig.KEY
const stripe = window.Stripe ? new Stripe(stripeKey, {
    locale: 'en',
}) : null
export default stripe


// WEBPACK FOOTER //
// ./web/js/administration/licenses/stripe.js